import { Switch } from '../../atoms';

export type NonProfitToggleProps = {
  value: boolean;
  disabled?: boolean;
  label: string;
  onChange: (newNonProfit: boolean) => void;
};

export const NonProfitToggle = ({ value, onChange, label, disabled }: NonProfitToggleProps) => (
  <Switch
    id="non-profit-toggle"
    className="non-profit-toggle"
    disabled={disabled}
    label={<div className="non-profit-toggle_label">{label}</div>}
    checked={value}
    onCheckedChange={onChange}
  />
);
